import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface InvoiceData {
  orderDetails: any;
  currencyLogo: string;
  currencyAbri: string;
  dataSource: any[];
  priceWithoutTax: number;
  tax: number;
  formattedTaxRates:string;
  logo: string;
  Address:any;
}

@Component({
  selector: 'app-restaurant-invoice',
  templateUrl: './restaurant-invoice.component.html',
  styleUrls: ['./restaurant-invoice.component.scss']
})
export class RestaurantInvoiceComponent {
  displayedColumns: string[] = ['Date','Itemname', 'Price', 'Quantity', 'Amount'];
  orderDetails: any;
  currencyLogo: string;
  currencyAbri: string;
  dataSource: any[];
  priceWithoutTax: number;
  tax: number;
  formattedTaxRates:string;
  logo: string;
  Address: any;
  GuestName;
  RestaurantAddress
  constructor(@Inject(MAT_DIALOG_DATA) public data: InvoiceData, private dialogRef: MatDialogRef<RestaurantInvoiceComponent>) {
    this.orderDetails = data.orderDetails;
    this.currencyLogo = data.currencyLogo;
    this.currencyAbri = data.currencyAbri;
    this.dataSource = data.dataSource;
    this.priceWithoutTax = data.priceWithoutTax;
    this.tax = data.tax;
    this.formattedTaxRates =data.formattedTaxRates;
    this.logo = data.logo
    this.Address = data.Address;
  }
  ngOnInit(){
    this.GuestName = (this.orderDetails?.guestName?.replace(/_/g, ' ')) || 'Guest';
    this.RestaurantAddress = this.orderDetails?.BillingAddress?.[0] || '';
  }

  getTotalCost() {
    return this.dataSource.map(t => t.Amount).reduce((acc, value) => acc + value, 0);
  }
  close(){
    this.dialogRef.close();
  }

  print() {
    const printContents = document.getElementById("print").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }
}